import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

interface Props {
  size: number;
  color: string;
}

export default function MagicIcon({ size, color }: Props) {
  return (
    <AutoFixHighIcon sx={{ fontSize: size, color }} />
  )
}
